import React from "react";
import { ArrowLeft, Eye, Factory, PaintBucket, User } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("tr-TR") : "");

const BoyahaneCard = ({ production, canEdit, onDetails, onReturn, onPainted, onAksesuar }) => (
  <Card className="border-purple-200" data-testid={`boyahane-card-${production.id}`}>
    <CardContent className="p-4">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="font-semibold text-lg">{production.customer_name}</h3>
            {production.cnc_completed && <span className="bg-green-100 text-green-700 text-xs font-medium px-2 py-1 rounded">✅ CNC</span>}
            {production.aksesuar_ready && <span className="bg-indigo-100 text-indigo-700 text-xs font-medium px-2 py-1 rounded">✅ Aksesuar Hazır</span>}
          </div>
          <p className="text-sm text-gray-600">{production.model} - {production.color}</p>
          {production.end_customer && (
            <p className="text-xs text-blue-600 mt-1"><User className="h-3 w-3 inline mr-1" />Nihai Tüketici: {production.end_customer}</p>
          )}
          {production.target_installation_date && (
            <p className="text-xs text-amber-600 font-medium mt-1">🎯 Hedef Montaj: {fmtDate(production.target_installation_date)}</p>
          )}
          {production.planned_installation_date && (
            <p className="text-xs text-blue-600 font-medium mt-1">📅 Planlanan Montaj: {fmtDate(production.planned_installation_date)}</p>
          )}
          {production.boyahane_date && (
            <p className="text-xs text-purple-600 font-medium mt-1">🎨 Boyahaneye giriş: {fmtDate(production.boyahane_date)}</p>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          <Button size="sm" variant="outline" onClick={() => onDetails(production)} data-testid={`boyahane-details-${production.id}`}>
            <Eye className="h-4 w-4 mr-1" /> Sipariş Detayı
          </Button>
          {canEdit && (
            <>
              <Button size="sm" className={production.aksesuar_ready ? "bg-green-600 hover:bg-green-700" : "bg-indigo-600 hover:bg-indigo-700"}
                onClick={() => onAksesuar(production.id)} data-testid={`boyahane-aksesuar-${production.id}`}>
                {production.aksesuar_ready ? "✅ Aksesuar Hazır" : "Aksesuar Hazırla"}
              </Button>
              <Button size="sm" className="bg-orange-600 hover:bg-orange-700" onClick={() => onReturn(production.id)} data-testid={`boyahane-return-${production.id}`}>
                <ArrowLeft className="h-4 w-4 mr-1" /> Üretime Geri Aktar
              </Button>
              <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={() => onPainted(production.id)} data-testid={`boyahane-painted-${production.id}`}>
                <PaintBucket className="h-4 w-4 mr-1" /> Boyandı
              </Button>
            </>
          )}
        </div>
      </div>
    </CardContent>
  </Card>
);

export const BoyahaneList = ({ items, ...actions }) =>
  items?.length > 0 ? (
    <div className="grid gap-4" data-testid="boyahane-list">
      {items.map((p) => <BoyahaneCard key={p.id} production={p} {...actions} />)}
    </div>
  ) : (
    <div className="text-center py-12" data-testid="boyahane-empty">
      <Factory className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <p className="text-lg text-gray-600">Boyahanede sipariş yok</p>
    </div>
  );
